import './polyfills.js';
import 'whatwg-fetch';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import './main.css';
import toggleExpandCollapse from './collapse.js';
import initDropdowns from './dropdown.js';
import toggleTabs from './tabs.js';
import initSearchbars from "./searchbar.js";
import navHandlers from "./nav.js";
import printHandler from './print.js';
import versionsRedirectHandler from "./versions.js";
import feedbackHandlers from "./feedback.js";
import shareHandlers from "./share.js";
import initInputsWithMaxLength from "./formutil.js";
import authUrlHandler from './auth.js';
import langHandlers from "./translate.js";
import initPdf from './pdf.js';
import profileHandlers from "./profile.js";
import quickfeedback from './quickfeedback.js';

let siteLoader;
let siteLoaderTimeout;


document.addEventListener('click', e => {
    navHandlers.navHandler(e);
    toggleExpandCollapse(e);
    toggleTabs(e);
    printHandler(e);
    versionsRedirectHandler(e);
    feedbackHandlers.feedbackBtnHandler(e);
    shareHandlers.shareBtnHandler(e);
    authUrlHandler(e);
    profileHandlers.toggleProfileHandler(e);
});

document.addEventListener('change', e => {
    langHandlers.changeLangSetting(e);
});

document.addEventListener('DOMContentLoaded', e => {
    siteLoader = document.querySelector('.site-loader-modal');
    siteLoaderTimeout = setTimeout( () => {siteLoader.classList.add('show')}, 1000);
    feedbackHandlers.initFeedbackForm();
    shareHandlers.initShareForm();
    quickfeedback.initQuickFB();
    initSearchbars();
    initPdf();
    initInputsWithMaxLength();
    initDropdowns();
    profileHandlers.loadProfileSettings();
});

window.addEventListener('load', e => {
    clearTimeout(siteLoaderTimeout);
    siteLoader.classList.remove('show');
    navHandlers.scrollNavToActive();
    navHandlers.scrollMainToActive();
});


window.addEventListener('popstate', e => {
    navHandlers.backHandler(e);
});